import gql from 'graphql-tag';

import { PhotoThumbnails } from './album';
import { AlbumFolderDetails } from './album-folder';
import { RosterIdentityBaseDetails } from './roster-identity';

export const AccountIdentityName = gql`
  fragment AccountIdentityName on Identity {
    account_identity_name {
      id
      name
      last_name
    }
  }
`;

export const IdentityDetailsBase = gql`
  fragment IdentityDetailsBase on Identity {
    id
    relationship
    name
    last_name
    has_outdated_selfie
    gender
    current_photo {
      ...PhotoThumbnails
    }
    current_matching_photo {
      ...PhotoThumbnails
    }
    ...AccountIdentityName
  }
  ${PhotoThumbnails}
  ${AccountIdentityName}
`;

export const IdentityDetails = gql`
  fragment IdentityDetails on Identity {
    id
    ...IdentityDetailsBase
  }
  ${IdentityDetailsBase}
`;

export const IdentityJoinedAlbums = gql`
  fragment IdentityJoinedAlbums on Identity {
    id
    matched_photos_extended {
      total
    }
    entitled_matched_photos {
      total
    }
    album_memberships(claimed_status_filter: CLAIMED) {
      records {
        matched_photos_extended {
          total
        }
        album {
          id
          root_album_folder {
            id
          }
        }
      }
    }
  }
`;

export const IdentityDetailsWithPurchasedAlbumFolders = gql`
  fragment IdentityDetailsWithPurchasedAlbumFolders on Identity {
    id
    relationship
    name
    current_photo {
      ...PhotoThumbnails
    }
    purchased_album_folders {
      records {
        ...AlbumFolderDetails
      }
    }
  }
  ${PhotoThumbnails}
  ${AlbumFolderDetails}
`;

export const IdentityAlbumFolderTagBaseDetails = gql`
  fragment IdentityAlbumFolderTagBaseDetails on IIdentityAlbumFolderTag {
    album_folder_tag {
      ... on IRecord {
        id
      }
      ... on IAlbumFolderTag {
        type
      }
      ... on UniformAlbumFolderTag {
        id
      }
      ... on GradeAlbumFolderTag {
        id
        name
      }
    }
  }
`;

export const IdentityAlbumFolderUniformTagDetails = gql`
  fragment IdentityAlbumFolderUniformTagDetails on IdentityUniformAlbumFolderTag {
    uniform_album_folder_tag_level {
      id
    }
    uniform_album_folder_tag_level_team {
      id
    }
    jersey_number
  }
`;

export const AlbumFolderIdentityDetails = gql`
  fragment AlbumFolderIdentityDetails on Identity {
    id
    name
    last_name
    school_grade
    relationship
    matched_photo_notifications(
      album_folder_id: $id
      slice: { limit: 1 }
      without_invitees: true
    ) {
      total
      records {
        created_at
      }
    }
    matched_photos_extended(album_folder_id: $id, without_invitees: true) {
      total
    }
    current_matching_photo {
      ...PhotoThumbnails
    }
    current_photo {
      ...PhotoThumbnails
    }
    face_highlighted_photos(album_folder_id: $id) {
      total
    }
    account {
      id
      name
      phone_number
      current_selfie {
        ...PhotoThumbnails
      }
    }
    ...AccountIdentityName
    purchased_album_folders(slice: { limit: 9999 }) {
      records {
        id
      }
    }
    album_folder_tags(album_folder_id: $id) {
      records {
        id
        ...IdentityAlbumFolderTagBaseDetails
        ...IdentityAlbumFolderUniformTagDetails
      }
    }
    roster_identity {
      id
      ...RosterIdentityBaseDetails
      purchased_custom_prints {
        total
      }
    }
  }
  ${PhotoThumbnails}
  ${AccountIdentityName}
  ${IdentityAlbumFolderTagBaseDetails}
  ${IdentityAlbumFolderUniformTagDetails}
  ${RosterIdentityBaseDetails}
`;
